module.exports = __webpack_public_path__ + "media/images/categories/bk-ed7dd331f1c510d42a0af0bf3eeb5e47.png";